import { THEME_LIGHT, useThemeContext } from "@hoylu/client-common";
import { useMemo } from "react";
import flowPreviewUrl from "../assets/images/flow.png";
import defaultPreviewUrl from "../assets/images/modules/blank.png";
import darkPreviewUrl from "../assets/images/modules/dark_blank.png";
import sketchPreviewUrl from "../assets/images/sketch.png";
import type { DocumentType } from "../state/workspaces/types";

export const useWorkspaceDefaultImage = (type?: DocumentType): string => {
  const themeContext = useThemeContext();

  return useMemo(() => {
    switch (type) {
      case "SKETCH":
        return sketchPreviewUrl;
      case "FLOW":
        return flowPreviewUrl;
      default:
        return themeContext.theme === THEME_LIGHT
          ? defaultPreviewUrl
          : darkPreviewUrl;
    }
  }, [themeContext.theme]);
};
